import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "../config/authConfig";

// Create the MSAL instance
// This must be a singleton so we can access it outside of React components (e.g. in axios interceptors)
export const msalInstance = new PublicClientApplication(msalConfig);

// Initialize early to ensure it's ready
msalInstance.initialize().catch(console.error);
